import { push } from 'connected-react-router';

import {
    doSearch as doSearchAction,
    fetchAutocomplete as fetchAutocompleteAction,
    moreResults as moreResultsAction,
    updateQuery as updateQueryAction,
} from '../actions';
import { ISearchRequest } from '../api';
import { ThunkAction } from "../types";

export function updateQuery(query: ISearchRequest): ThunkAction {
    return async (dispatch) => {
        dispatch(updateQueryAction(query));

        // This has gotten way too slow
        // dispatch(fetchAutocomplete(query.query));
    };
}

export function fetchAutocomplete(query: string): ThunkAction {
    return async (dispatch, _, {subtitles}) => {
      try {
        await dispatch(fetchAutocompleteAction.request());
  
        const options = await subtitles.autocomplete(query);
  
        await dispatch(fetchAutocompleteAction.success(options));
      } catch (error) {
        await dispatch(fetchAutocompleteAction.failure(error));
        return;
      }
    }
  }

export function doSearch(): ThunkAction {
    return async (dispatch, getState, {subtitles}) => {
        const {search} = getState();
        const {query} = search;

        let url = `/search`;
        if (query) {
            url += `?q=${query.query}`;
        }
        dispatch<any>(push(url));

        dispatch(doSearchAction.request());
        try {
            if (!query) {
                return;
            }

            const results = await subtitles.search(query);

            dispatch(doSearchAction.success(results));
        } catch(error) {
            dispatch(doSearchAction.failure(error));            
        }
    };
}

export function moreResults(): ThunkAction {
    return async (dispatch, getState, {subtitles}) => {
        const {search} = getState();
        const {query} = search;

        dispatch(moreResultsAction.request());
        try {
            if (!query) {
                return;
            }
            
            const nextQuery = {
                ...query,
                offset: (query.offset || 0) + (query.limit || 20),
            };
            const results = await subtitles.search(nextQuery);

            dispatch(moreResultsAction.success({
                query: nextQuery,
                results,
            }));
        } catch(error) {
            dispatch(moreResultsAction.failure(error));            
        }
    };
}



// WEBPACK FOOTER //
// ./src/thunks/searchThunks.ts